import 'angular';
/* eslint-disable-next-line max-len */
import '../../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/bar-chart.directive';
import template from './news_topics_chart.template.html?raw';

const moduleDependencies = [
  'directives.visualizations.barChart',
];

const bindings = {
  searchJs: '<',
  chartData: '<',
  emptyResultsText: '<',
  colorRange: '<'
};

const newsTopicsChartController = function() {
  const that = this;
  /**
   * filterContainsValue: returns true if the provided value already exists
   * as a filter in news_topics.
   *
   * @param {object} value - object containing filter value
   * @returns {boolean}
   */
  that.filterContainsValue = value => {
    return that.searchJs.filter.news_topics.value.some(item => item.name === value);
  };

  /**
   * onFilterSelect callback for adding a filter parameter.
   * Adds the filter to searchJS
   * Makes a new search
   *
   * @param {object} value - value of news_topics filter
   * @returns {undefined}
   */
  that.onFilterSelect = (value) => {
    if (that.filterContainsValue(value)) {
      return;
    }
    that.searchJs.filter.news_topics.addValue({'name': value});
    that.searchJs.notifyParamChange();
  };

};

const controller = [newsTopicsChartController];

const options = {
  templateUrl: template,
  bindings,
  controller,
  controllerAs: 'vm'
};

angular
  .module('fundingSearchApp.components.newsTopicsChart', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('newsTopicsChart', options);
